<template>
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1946 3.23607L13.9377 8.60081L14.1622 9.2918H14.8887H20.5296L15.966 12.6074L15.3783 13.0344L15.6028 13.7254L17.3459 19.0902L12.7824 15.7746L12.1946 15.3475L11.6068 15.7746L7.04327 19.0902L8.78638 13.7254L9.01089 13.0344L8.42311 12.6074L3.85959 9.2918H9.50041H10.227L10.4515 8.60081L12.1946 3.23607Z" stroke="#D2A400" stroke-width="2"/>
  </svg>
</template>
